'use client'

import { useEffect } from 'react'
import { useRouterState } from '@tanstack/react-router'
import { usePathname } from '@/hooks/usePathname'
import { trackPageView } from '@/lib/posthog'

function PostHogPageView() {
  const pathname = usePathname()
  // location.searchStr is the canonical query string from TanStack Router —
  // stable as a string, so it compares cleanly in the effect deps. Reading
  // useSearch() instead returns a fresh object reference per router tick,
  // which would re-fire trackPageView on every render.
  const searchString = useRouterState({ select: (s) => s.location.searchStr })

  useEffect(() => {
    if (!pathname) return
    const url = pathname + (searchString || '')
    trackPageView(url)
  }, [pathname, searchString])

  return null
}

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  return (
    <>
      <PostHogPageView />
      {children}
    </>
  )
}
